// src/components/PrivateRoute.jsx
import React from "react";
import { Navigate } from "react-router-dom";
import { useSelector } from "react-redux";

const PrivateRoute = ({ children, roles = [] }) => {
  const { userInfo } = useSelector((state) => state.auth);

  if (!userInfo) return <Navigate to="/login" />;

  if (roles.length && !roles.includes(userInfo.user.role)) {
    return <Navigate to="/" />;
  }

  return children;
};

export default PrivateRoute;
